var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M7.14886 1.02071C8.55081 0.00213003 10.4492 0.00212795 11.8511 1.0207L17.1349 4.85962C18.5369 5.87819 19.1235 7.68366 18.588 9.33175L16.5698 15.5432C16.0343 17.1913 14.4985 18.3072 12.7656 18.3072H6.23442C4.50152 18.3072 2.9657 17.1913 2.4302 15.5432L0.411963 9.33176C-0.123534 7.68367 0.463098 5.87819 1.86505 4.85962L7.14886 1.02071Z",
    fill: "#E0B09C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon2);
export default __webpack_public_path__ + "static/media/polygon-2.e1d373c5beac04be0a10b5c5d7c05838.svg";
export { ForwardRef as ReactComponent };